// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"_640ef3a599ac369f","table":"_5e0b275c8f57984e","actions":"_0c1fdc4dd1a3962a","action":"c779a3e61e0bc4b4","wrapper":"_33bffeab4ada3afc"};